export default __webpack_public_path__ + "static/media/treat-yourself-480w.c47b00fc.png";